import axios from 'axios';
import { createContext, useReducer } from 'react';
import { userReducer } from '../reducers/userReducer';
import { apiUrl, DELETE_SUCCESS, LOAD_SUCCESS } from '../utils/constants';

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [userState, dispatch] = useReducer(userReducer, {
    userLoading: true,
    users: [],
    pagination: {
      totalItems: 0,
      page: 0,
      totalPages: 1,
      take: 10,
    },
  });

  const getUsers = async () => {
    try {
      const response = await axios.post(`${apiUrl}/users`, {
        page:
          userState?.users?.length > 0 &&
          userState?.pagination?.page < userState?.pagination?.totalPages
            ? (userState?.pagination?.page || 0) + 1
            : 1,
      });
      if (response?.status === 200) {
        dispatch({
          type: LOAD_SUCCESS,
          payload: {
            users: response?.data?.data?.items,
            pagination: response?.data?.data?.pagination,
          },
        });
      }

      return response?.data;
    } catch (error) {
      if (error?.response?.data) return error?.response?.data;
      else return { success: false, message: error?.message };
    }
  };

  const deleteUser = async (id) => {
    try {
      const response = await axios.delete(`${apiUrl}/users/${id}`);
      if (response?.status === 200) {
        dispatch({
          type: DELETE_SUCCESS,
          payload: {
            ...userState,
            user: response?.data?.data,
          },
        });
      }

      return response?.data;
    } catch (error) {
      if (error?.response?.data) return error?.response?.data;
      else return { success: false, message: error?.message };
    }
  };

  const userContextData = {
    getUsers,
    userState,
    deleteUser,
  };

  return (
    <UserContext.Provider value={userContextData}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
